import axios from "axios";
import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import LayoutPage from "../Layout";
import swal from "sweetalert2";
import * as Yup from "yup";
import styled from "styled-components";

function PodcastDetail() {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [heading, setHeading] = useState("");
  const [descriptionData, setDescriptionData] = useState("");
  const [newContent, setNewContent] = useState({});
  const [url, setUrl] = useState();
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValue, setInitialValues] = useState({
    heading: "",
    description: "",
    podcastUrl: "",
  });

  const validationSchema = Yup.object().shape({
    heading: Yup.string().max(50),
    description: Yup.string().max(100),
    podcastUrl: Yup.string()
      .url("Podcast URL must be a valid URL")
  });

  const handleSubmit = async()=>{
    try {
      const values ={
        heading,
        description: descriptionData,
        podcastUrl: url,
      }
      let res = await axios.patch(
        `admin-website/update-podcast/${id}`,
        values
      );
      // console.log("res ==> ", res);
      toast(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
      });

      navigate(-1);

      // navigate("/category", { state: { message: res.data.message } });
    } catch (errors) {
      if (errors.response.data.error) {
        toast(errors.response.data.error.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
        });
      }
      // setDisabledSubmit(false);
    }
  }

  useEffect(() => {
    setLoading(true);
    axios
      .get(`/admin-website/get-podcast/${id}`)
      .then((res) => res.data.data)
      .then((data) => {
        // console.log(data);
        setInitialValues({
          heading: data.heading,
          description: data.description,
          podcastUrl: data.podcastUrl,
        });
        setUrl(data.podcastUrl);
        setHeading(data.heading);
        setTitle(data.topic);
        setDescriptionData(data.description);
        setLoading(false);
      });
  }, []);

  const newContentData = {
    pageContent: newContent,
  };

  return (
    <>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-4 pb-3"
                >
                  <div className="d-flex ps-3 align-item-center">
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate(-1);
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">
                      PODCAST VIDEOS
                    </h6>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <Formik
                    initialValues={initialValue}
                    validationSchema={validationSchema}
                    enableReinitialize
                    onSubmit={handleSubmit}
                  >
                    <Form>
                      <div className="input-group input-group-outline mb-3">
                        <label className="fs-5">Topic: </label>
                        <label className="fs-5 mx-2">{title}</label>
                      </div>

                      <div className="input-group input-group-outline mb-3">
                        <label className="fs-5">Heading</label>

                        <Field
                          style={{ width: "100%" }}
                          type="text"
                          id="heading"
                          name="heading"
                          className="form-control fs-6"
                          autoComplete="off"
                          placeholder="Heading"
                          value={heading}
                          onChange={(e) => setHeading(e.target.value)}
                        />
                        <Error>
                          <ErrorMessage
                            name="heading"
                            component="div"
                            className="error"
                          />
                        </Error>
                      </div>

                      <div className="input-group input-group-outline mb-3">
                        <label className="fs-5">Description</label>
                        <Field
                          style={{ width: "100%" }}
                          type="text"
                          id="description"
                          name="description"
                          className="form-control fs-6"
                          autoComplete="off"
                          placeholder="Description "
                          value={descriptionData}
                          onChange={(e) => setDescriptionData(e.target.value)}
                        />
                        <Error>
                          <ErrorMessage
                            name="description"
                            component="div"
                            className="error"
                          />
                        </Error>
                      </div>

                      <div className="input-group input-group-outline mb-3">
                        <label className="fs-5">URL</label>

                        <Field
                          style={{ width: "100%" }}
                          type="text"
                          id="podcastUrl"
                          name="podcastUrl"
                          className="form-control fs-6"
                          autoComplete="off"
                          placeholder="Podcast URL "
                          value={url}
                          onChange={(e) => setUrl(e.target.value)}
                        />
                        <Error>
                          <ErrorMessage
                            name="podcastUrl"
                            component="div"
                            className="error"
                          />
                        </Error>
                      </div>

                      <button
                        type="submit"
                        className="Submit my-3 btn-lg w-20 mt-4 mb-0 "
                        style={{
                          // width: "200px",
                          borderRadius: "5px",
                          height: "50px",
                          marginLeft: "450px",
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                        // onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default PodcastDetail;

const Error = styled.div`
  .error {
    color: red;
  }
`;
